export const SCHEDULE_STATUS = {
  ACTIVE: 1000,
  INACTIVE: 1001,
} as const;

export interface ReportTemplate {
  id: string;
  title: string;
}

export interface RunReportModalData {
  template: ReportTemplate;
}

export interface RunReportRequest {
  organizationId: number;
  providerId?: number;
  reportingYear: number;
  emails?: string[];
}

export interface ReportResult {
  id: number;
  reportId: number;
  reportName: string;
  scheduleId: number | null;
  scheduleName: string;
  cadence: string | null;
  providerId: string | null;
  providerName: string | null;
  organizationId: number | null;
  runDate: string;
  createdBy: string;
  statusId: number;
}

export interface ReportResultsResponse {
  results: ReportResult[];
  totalCount: number;
}

export interface ScheduleResponse {
  id: number;
  reportId: number;
  reportName: string;
  organizationId: number | null;
  cadence: string | null;
  providerId: string | null;
  providerName: string | null;
  startDate: string | null;
  endDate: string | null;
  scheduleName: string;
  emailRecipients: string | null;
  statusId: number;
}

export interface SchedulesResponse {
  schedules: ScheduleResponse[];
  totalCount: number;
}

export interface ProviderScheduleEntry {
  id: string;
  email: string | null;
}

export interface CreateScheduleRequest {
  reportName: string;
  organizationId?: number;
  cadence: string;
  providers: ProviderScheduleEntry[];
  startDate: string;
  endDate: string;
  timeZoneId: string;
  scheduleName: string;
  emailRecipients?: string | null;
}

export interface CreateSchedulesResponse {
  schedules: ScheduleResponse[];
  totalCount: number;
}

export interface BulkRunReportRequest {
  organizationId?: number;
  providers: ProviderScheduleEntry[];
  reportingYear?: number;
  emailRecipients: string[] | null;
}

export interface BulkRunReportResponse {
  queuedProviderIds: string[];
  failedProviderIds: string[];
  partialSuccess: boolean;
  error?: string;
}

export interface UpdateScheduleRequest {
  cadence: string;
  providerId: string;
  startDate: string;
  endDate: string;
  timeZoneId: string;
  scheduleName: string;
  emailRecipients?: string | null;
}

export interface ScheduleReportModalData {
  template: ReportTemplate;
  schedule?: ScheduleResponse;
}
